import { isServer } from 'tradera/utils/nextjs';

// expect sellingGlobalConfig to exist on global window type
declare global {
    interface Window {
        sellingGlobalConfig?: SellingJsConfig;
    }
}
type SellingJsConfig = {
    draftImagesUrl: string;
    templateImagesUrl: string;
    myTraderaUrl: string;
    isVatRequired: boolean;
    selectableVatValues: number[];
    isHybridAppContext: boolean;
    isHybridAppWithHtmlUploadSupport: boolean;
    isSyiNonBlockingPublishedPageEnabled: boolean;
    isHtmlEnabled: boolean;
    commissionMinimum: number;
    commissionCap: number;
    highlightFeaturePrice: number;
    rankUpFeaturePrice: number;
    isAddonsEnabled: boolean;
    isSyiAddPhotoNativeAppEnabled: boolean;
    isSyiMemberConsentEnabled: boolean;
    isSyiTenImagesEnabled: boolean;
};

const config = {
    ...((!isServer && window.sellingGlobalConfig) || {
        draftImagesUrl: '',
        templateImagesUrl: '',
        myTraderaUrl: '',
        isVatRequired: false,
        selectableVatValues: [],
        isHybridAppContext: false,
        isHybridAppWithHtmlUploadSupport: false,
        isSyiNonBlockingPublishedPageEnabled: false,
        isHtmlEnabled: false,
        commissionMinimum: 0,
        commissionCap: 0,
        highlightFeaturePrice: 0,
        rankUpFeaturePrice: 0,
        isAddonsEnabled: false,
        isSyiAddPhotoNativeAppEnabled: false,
        isSyiMemberConsentEnabled: false,
        isSyiTenImagesEnabled: false
    }),
    maxTemplates: 100,
    domainNameCategoryId: 344477
};

config.maxTemplates = 100;
config.domainNameCategoryId = 344477;

export default config;
